// import React, { useEffect, useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { Col, Row, Form, Button, Container } from "react-bootstrap";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { toast } from "react-toastify";
// import { Autocomplete, TextField } from "@mui/material";
// import BootstrapTextField from "Common/BootstrapTextField";
// import { useDispatch } from "react-redux";
// import { addBlock as onAddBlock } from "slices/block/thunk";
// import { fetchPackages } from "slices/package/thunk";
// import { fetchDistricts } from "slices/district/thunk";
// import FileUploadInput from "Common/Components/FileUploadInput/FileUploadInput";
// import {
//   fetchGPs,
//   fetchItemSKUs,
//   fetchMaterials,
//   fetchRingIds,
//   fetchSpanIds,
//   fetchSubCategories,
//   fetchCategories,
//   fetchSupervisorDropDown,
//   fetchUnits,
// } from "slices/transfer_from/fieldStock/thunk";

// interface FieldStockItem {
//   material_name: string;
//   item_name: string;
//   itemSKU: string;
//   unit: string;
//   category: string;
//   subCategory: string;
//   quantity: number;
//   remarks: string;
//   make: string;
//   model: string;
// }

// interface FieldStockFormValues {
//   transfer_date: string;
//   stock_transfer_id: string;
//   transfer_from: string;
//   initiatedBy: string;
//   spanId: string;
//   gp: string;
//   latLong: string;
//   remarks: string;
//   transferitems: FieldStockItem[];
//   document?: File;
// }

// const CreateStockTransferForm: React.FC = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch<any>();
//   const [itemName, setItemName] = useState<{
//     itemName: string;
//     unitName: string;
//   } | null>(null);
//   const [quantity, setQuantity] = useState("");
//   const [remarks, setRemarks] = useState("");

//   const [packageOptions, setPackageOptions] = useState<any[]>([]);
//   const [supplierOptions2, setSupplierOptions] = useState<any[]>([]);

//   const [supervisorOptions, setSupervisorOptions] = useState<any[]>([]);
//   const [ringIdOptions, setRingIdOptions] = useState<any[]>([]);
//   const [spanIdOptions, setSpanIdOptions] = useState<any[]>([]);
//   const [gpOptions, setGpOptions] = useState<any[]>([]);

//   const [materialOptions, setMaterialOptions] = useState<any[]>([]);
//   const [itemSKUOptions, setItemSKUOptions] = useState<any[]>([]);
//   const [unitOptions, setUnitOptions] = useState<any[]>([]);
//   const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
//   const [subCategoryOptions, setSubCategoryOptions] = useState<any[]>([]);

//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const [
//           pkgRes,
//           distRes,
//           supervisorRes,
//           ringIdRes,
//           spanIdRes,
//           gpRes,
//           materialRes,
//           itemSKURes,
//           unitRes,
//           categoryRes,
//           subCategoryRes,
//         ] = await Promise.all([
//           dispatch(fetchPackages({ page: 1, pageSize: 100 })).unwrap(),
//           dispatch(fetchDistricts({ page: 1, pageSize: 100 })).unwrap(),
//           dispatch(fetchSupervisorDropDown()).unwrap(),
//           dispatch(fetchRingIds()).unwrap(),
//           dispatch(fetchSpanIds()).unwrap(),
//           dispatch(fetchGPs()).unwrap(),
//           dispatch(fetchMaterials()).unwrap(),
//           dispatch(fetchItemSKUs()).unwrap(),
//           dispatch(fetchUnits()).unwrap(),
//           dispatch(fetchCategories()).unwrap(),
//           dispatch(fetchSubCategories()).unwrap(),
//         ]);
//         setPackageOptions(pkgRes?.data || []);
//         setSupplierOptions(distRes?.data || []);
//         setSupervisorOptions(supervisorRes?.data || []);
//         setRingIdOptions(ringIdRes?.data || []);
//         setSpanIdOptions(spanIdRes?.data || []);
//         setGpOptions(gpRes?.data || []);
//         setMaterialOptions(materialRes?.data || []);
//         setItemSKUOptions(itemSKURes?.data || []);
//         setUnitOptions(unitRes?.data || []);
//         setCategoryOptions(categoryRes?.data || []);
//         setSubCategoryOptions(subCategoryRes?.data || []);
//       } catch (err) {
//         toast.error("Failed to fetch dropdown data");
//       }
//     };

//     fetchDropdowns();
//   }, [dispatch]);

//   const formik = useFormik<FieldStockFormValues>({
//     initialValues: {
//       transfer_date: "",
//       stock_transfer_id: "",
//       transfer_from: "",
//       initiatedBy: "",
//       spanId: "",
//       gp: "",
//       latLong: "",
//       remarks: "",
//       transferitems: [],
//       document: undefined,
//     },
//     validationSchema: Yup.object({
//       transfer_date: Yup.string().required("Please select a transfer_date"),
//       stock_transfer_id: Yup.string().required("Please enter Field Stock Id"),
//       transfer_from: Yup.string().required("Please select a Supervisor"),
//       initiatedBy: Yup.string().required("Please select a Ring Id"),
//       spanId: Yup.string().required("Please select a Span Id"),
//       gp: Yup.string().required("Please select a GP"),
//       latLong: Yup.string().required("Please enter Lat & Long"),
//       remarks: Yup.string().required("Please enter Remarks"),
//       transferitems: Yup.array()
//         .of(
//           Yup.object().shape({
//             item_name: Yup.string().required("Required"),
//             remarks: Yup.string(),
//             quantity: Yup.number().required("Required").positive("Must be > 0"),
//             unit: Yup.string().required("Required"),
//           })
//         )
//         .min(1, "At least one item is required"),
//     }),
//     onSubmit: async (values) => {
//       const payload = {
//         ...values,
//         created_by: "Admin",
//         updated_by: "Admin",
//       };
//       try {
//         await dispatch(onAddBlock(payload) as any);
//         toast.success("FieldStock added successfully");
//         navigate("/rfq");
//       } catch (err) {
//         toast.error("Something went wrong");
//       }
//     },
//   });

//   return (
//     <>
//       <div
//         className="page-content px-4"
//         // style={{ backgroundColor: "#e9ecef", minHeight: "100vh" }}
//       >
//         <Container
//           fluid
//           style={{
//             background: "#fff",
//             borderRadius: "10px",
//             padding: "30px",
//             boxShadow: "0 0 15px rgba(0,0,0,0.05)",
//           }}
//         >
//           <div>
//             <Form autoComplete="off" onSubmit={formik.handleSubmit}>
//               <Row className="align-items-center mb-4">
//                 <Col lg="auto">
//                   <Link
//                     to="/rfq"
//                     style={{ color: "inherit", textDecoration: "none" }}
//                   >
//                     <i
//                       className="bi bi-arrow-left"
//                       style={{ fontSize: "1.2rem", cursor: "pointer" }}
//                       aria-label="Back to Purchase Request"
//                     />
//                   </Link>
//                 </Col>
//                 <Col lg={3} className="me-auto">
//                   <h6 className="card-title mb-0">Create Stock Transfer</h6>
//                 </Col>
//               </Row>
//               <Row>
//                 <Col lg={3}>
//                   <div className="mb-4">
//                     <Form.Label>
//                       Date <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       type="transfer_date"
//                       name="transfer_date"
//                       value={formik.values.transfer_date}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       isInvalid={!!formik.errors.transfer_date && formik.touched.transfer_date}
//                     />
//                     <Form.Control.Feedback type="invalid">
//                       {formik.errors.transfer_date}
//                     </Form.Control.Feedback>
//                   </div>
//                 </Col>

//                 {/* Field Stock Id */}
//                 <Col lg={3}>
//                   <div className="mb-3">
//                     <Form.Label>
//                       Field Stock Id <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="stock_transfer_id"
//                       placeholder="Enter Field Stock Id"
//                       value={formik.values.stock_transfer_id}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       isInvalid={
//                         !!formik.errors.stock_transfer_id &&
//                         formik.touched.stock_transfer_id
//                       }
//                     />
//                     <Form.Control.Feedback type="invalid">
//                       {formik.errors.stock_transfer_id}
//                     </Form.Control.Feedback>
//                   </div>
//                 </Col>

//                 {/* Supervisor */}
//                 <Col lg={3}>
//                   <div className="mb-4">
//                     <Form.Label>
//                       Supervisor <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Autocomplete
//                       options={supervisorOptions}
//                       getOptionLabel={(option: any) =>
//                         typeof option === "string"
//                           ? option
//                           : option.supplier_name
//                       }
//                       value={
//                         supervisorOptions.find(
//                           (d: any) => d.id === formik.values.transfer_from
//                         ) || null
//                       }
//                       onChange={(event, selected) => {
//                         formik.setFieldValue("transfer_from", selected?.id || "");
//                       }}
//                       onBlur={() => formik.setFieldTouched("transfer_from", true)}
//                       renderInput={(params) => (
//                         <BootstrapTextField
//                           {...params}
//                           name="transfer_from"
//                           placeholder="Select Supervisor"
//                           error={
//                             formik.touched.transfer_from &&
//                             Boolean(formik.errors.transfer_from)
//                           }
//                           helperText={
//                             formik.touched.transfer_from &&
//                             formik.errors.transfer_from
//                           }
//                           fullWidth
//                           size="small"
//                         />
//                       )}
//                     />
//                   </div>
//                 </Col>

//                 {/* Ring Id  */}
//                 <Col lg={3}>
//                   <div className="mb-4">
//                     <Form.Label>
//                       Ring Id <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Autocomplete
//                       options={ringIdOptions}
//                       getOptionLabel={(option: any) =>
//                         typeof option === "string" ? option : option.initiatedBy
//                       }
//                       value={
//                         ringIdOptions.find(
//                           (d: any) => d.id === formik.values.initiatedBy
//                         ) || null
//                       }
//                       onChange={(event, selected) => {
//                         formik.setFieldValue("initiatedBy", selected?.id || "");
//                       }}
//                       onBlur={() => formik.setFieldTouched("initiatedBy", true)}
//                       renderInput={(params) => (
//                         <BootstrapTextField
//                           {...params}
//                           name="initiatedBy"
//                           placeholder="Select RING Id"
//                           error={
//                             formik.touched.initiatedBy &&
//                             Boolean(formik.errors.initiatedBy)
//                           }
//                           helperText={
//                             formik.touched.initiatedBy && formik.errors.initiatedBy
//                           }
//                           fullWidth
//                           size="small"
//                         />
//                       )}
//                     />
//                   </div>
//                 </Col>
//                 {/* Span Id */}
//                 <Col lg={3}>
//                   <div className="mb-4">
//                     <Form.Label>
//                       Span Id <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Autocomplete
//                       options={spanIdOptions}
//                       getOptionLabel={(option: any) =>
//                         typeof option === "string" ? option : option.spanId
//                       }
//                       value={
//                         spanIdOptions.find(
//                           (d: any) => d.id === formik.values.spanId
//                         ) || null
//                       }
//                       onChange={(event, selected) => {
//                         formik.setFieldValue("spanId", selected?.id || "");
//                       }}
//                       onBlur={() => formik.setFieldTouched("spanId", true)}
//                       renderInput={(params) => (
//                         <BootstrapTextField
//                           {...params}
//                           name="spanId"
//                           placeholder="Select Span Id"
//                           error={
//                             formik.touched.spanId &&
//                             Boolean(formik.errors.spanId)
//                           }
//                           helperText={
//                             formik.touched.spanId && formik.errors.spanId
//                           }
//                           fullWidth
//                           size="small"
//                         />
//                       )}
//                     />
//                   </div>
//                 </Col>
//                 {/* GP */}
//                 <Col lg={3}>
//                   <div className="mb-4">
//                     <Form.Label>
//                       GP <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Autocomplete
//                       options={gpOptions}
//                       getOptionLabel={(option: any) =>
//                         typeof option === "string" ? option : option.gp
//                       }
//                       value={
//                         gpOptions.find((d: any) => d.id === formik.values.gp) ||
//                         null
//                       }
//                       onChange={(event, selected) => {
//                         formik.setFieldValue("gp", selected?.id || "");
//                       }}
//                       onBlur={() => formik.setFieldTouched("gp", true)}
//                       renderInput={(params) => (
//                         <BootstrapTextField
//                           {...params}
//                           name="gp"
//                           placeholder="Select GP"
//                           error={formik.touched.gp && Boolean(formik.errors.gp)}
//                           helperText={formik.touched.gp && formik.errors.gp}
//                           fullWidth
//                           size="small"
//                         />
//                       )}
//                     />
//                   </div>
//                 </Col>

//                 <Col lg={3}>
//                   <div className="mb-3">
//                     <Form.Label>
//                       Lat & Long <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="latLong"
//                       placeholder="Enter Lat & Long"
//                       value={formik.values.latLong}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       isInvalid={
//                         !!formik.errors.latLong && formik.touched.latLong
//                       }
//                     />
//                     <Form.Control.Feedback type="invalid">
//                       {formik.errors.latLong}
//                     </Form.Control.Feedback>
//                   </div>
//                 </Col>

//                 <Col lg={3}>
//                   <FileUploadInput
//                     label="Attachment"
//                     name="document"
//                     formik={formik}
//                   />
//                 </Col>

//                 <Col lg={3}>
//                   <div className="mb-3">
//                     <Form.Label>
//                       Remarks <span className="text-danger">*</span>
//                     </Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="remarks"
//                       placeholder="Enter Remarks"
//                       value={formik.values.remarks}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       isInvalid={
//                         !!formik.errors.remarks && formik.touched.remarks
//                       }
//                     />
//                     <Form.Control.Feedback type="invalid">
//                       {formik.errors.remarks}
//                     </Form.Control.Feedback>
//                   </div>
//                 </Col>

//                 <Col lg={12} className="mt-4">
//                   <div className="mb-4 table-responsive">
//                     <table
//                       className="table align-middle text-center"
//                       style={{
//                         borderCollapse: "separate",
//                         borderSpacing: "0 10px",
//                       }}
//                     >
//                       <thead style={{ backgroundColor: "#DDE1EF" }}>
//                         <tr>
//                           <th style={{ minWidth: 80, border: "none" }}>
//                             Sr No.
//                           </th>
//                           <th style={{ minWidth: 150, border: "none" }}>
//                             Item Name
//                           </th>
//                           <th style={{ minWidth: 150, border: "none" }}>
//                             Unit
//                           </th>
//                           <th style={{ minWidth: 150, border: "none" }}>
//                             Category
//                           </th>
//                           <th style={{ minWidth: 150, border: "none" }}>
//                             Sub Category
//                           </th>
//                           <th style={{ minWidth: 150, border: "none" }}>
//                             Make
//                           </th>
//                           <th style={{ minWidth: 180, border: "none" }}>
//                             Model
//                           </th>
//                           <th style={{ minWidth: 100, border: "none" }}>
//                             In Stock
//                           </th>
//                           <th style={{ minWidth: 100, border: "none" }}>
//                             Transfer Quantity
//                           </th>
//                           <th style={{ minWidth: 100, border: "none" }}>
//                             Remarks
//                           </th>
//                           <th style={{ minWidth: 100, border: "none" }}>
//                             Action
//                           </th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td style={{ border: "none" }}>-</td>

//                           <td style={{ border: "none" }}>
//                             <Autocomplete
//                               options={[
//                                 { itemName: "item1", unitName: "unit1" },
//                                 { itemName: "item2", unitName: "unit2" },
//                               ]}
//                               getOptionLabel={(option) => option.itemName}
//                               value={itemName}
//                               onChange={(event, newValue) =>
//                                 setItemName(newValue)
//                               }
//                               renderInput={(params) => (
//                                 <TextField
//                                   {...params}
//                                   placeholder="Select"
//                                   variant="outlined"
//                                   size="small"
//                                 />
//                               )}
//                             />
//                           </td>
//                           <td style={{ border: "none" }}>
//                             <Autocomplete
//                               options={[
//                                 { itemName: "item1", unitName: "unit1" },
//                                 { itemName: "item2", unitName: "unit2" },
//                               ]}
//                               getOptionLabel={(option) => option.unitName}
//                               value={itemName}
//                               onChange={(event, newValue) =>
//                                 setItemName(newValue)
//                               }
//                               renderInput={(params) => (
//                                 <TextField
//                                   {...params}
//                                   placeholder="Select"
//                                   variant="outlined"
//                                   size="small"
//                                 />
//                               )}
//                             />
//                           </td>

//                           <td style={{ border: "none" }}>-</td>

//                           <td style={{ border: "none" }}>-</td>
//                           <td style={{ border: "none" }}>
//                             <Autocomplete
//                               options={[
//                                 { itemName: "item1", unitName: "unit1" },
//                                 { itemName: "item2", unitName: "unit2" },
//                               ]}
//                               getOptionLabel={(option) => option.unitName}
//                               value={itemName}
//                               onChange={(event, newValue) =>
//                                 setItemName(newValue)
//                               }
//                               renderInput={(params) => (
//                                 <TextField
//                                   {...params}
//                                   placeholder="Select"
//                                   variant="outlined"
//                                   size="small"
//                                 />
//                               )}
//                             />
//                           </td>
//                           <td style={{ border: "none" }}>
//                             <Autocomplete
//                               options={[
//                                 { itemName: "item1", unitName: "unit1" },
//                                 { itemName: "item2", unitName: "unit2" },
//                               ]}
//                               getOptionLabel={(option) => option.unitName}
//                               value={itemName}
//                               onChange={(event, newValue) =>
//                                 setItemName(newValue)
//                               }
//                               renderInput={(params) => (
//                                 <TextField
//                                   {...params}
//                                   placeholder="Select"
//                                   variant="outlined"
//                                   size="small"
//                                 />
//                               )}
//                             />
//                           </td>
//                           <td style={{ border: "none" }}>-</td>

//                           <td style={{ border: "none" }}>
//                             <Form.Control
//                               placeholder="Enter Quantity"
//                               type="number"
//                               value={quantity}
//                               onChange={(e) => setQuantity(e.target.value)}
//                               size="sm"
//                             />
//                           </td>
//                           <td style={{ border: "none" }}>
//                             <Form.Control
//                               placeholder="Enter Remark"
//                               type="text"
//                               value={quantity}
//                               onChange={(e) => setQuantity(e.target.value)}
//                               size="sm"
//                             />
//                           </td>

//                           <td style={{ border: "none" }}>
//                             <Button
//                               style={{
//                                 background: "#3F7DDA",
//                                 color: "#FFF",
//                               }}
//                               onClick={() => {
//                                 if (itemName && quantity) {
//                                   formik.setFieldValue("transferitems", [
//                                     ...formik.values.transferitems,
//                                     {
//                                       item_name: itemName.itemName,
//                                       unit: itemName.unitName,
//                                       quantity: parseFloat(quantity),
//                                       remarks,
//                                     },
//                                   ]);
//                                   setItemName(null);
//                                   setQuantity("");
//                                   setRemarks("");
//                                 }
//                               }}
//                             >
//                               Add
//                             </Button>
//                           </td>
//                         </tr>

//                         {formik.values.transferitems.map((item, index) => (
//                           <tr key={index}>
//                             <td style={{ border: "none" }}>{index + 1}</td>
//                             <td style={{ border: "none" }}>
//                               {item?.item_name}
//                             </td>
//                             <td style={{ border: "none" }}>{item?.unit}</td>
//                             <td style={{ border: "none" }}>-</td>
//                             <td style={{ border: "none" }}>-</td>
//                             <td style={{ border: "none" }}>{item.make}</td>
//                             <td style={{ border: "none" }}>{item.model}</td>
//                             <td style={{ border: "none" }}>-</td>
//                             <td style={{ border: "none" }}>{item.quantity}</td>
//                             <td style={{ border: "none" }}>{item.quantity}</td>
//                             {/* <td style={{ border: "none" }}>-</td> */}

//                             <td style={{ border: "none" }}>
//                               <Button
//                                 size="sm"
//                                 variant="light"
//                                 onClick={() => {
//                                   const updatedItems = [
//                                     ...formik.values.transferitems,
//                                   ];
//                                   updatedItems.splice(index, 1);
//                                   formik.setFieldValue(
//                                     "transferitems",
//                                     updatedItems
//                                   );
//                                 }}
//                               >
//                                 <i
//                                   style={{ color: "red", fontSize: 17 }}
//                                   className="bi bi-trash-fill"
//                                 ></i>
//                               </Button>
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </Col>
//               </Row>

//               <div className="d-flex justify-content-center gap-3 py-3">
//                 <Button variant="light" style={{ border: "1px solid #ced4da" }}>
//                   <Link
//                     to="/rfq"
//                     className="text-decoration-none"
//                     style={{ color: "#495057" }}
//                   >
//                     Cancel
//                   </Link>
//                 </Button>

//                 <Button
//                   type="submit"
//                   style={{ background: "#3F7DDA", color: "#FFF" }}
//                 >
//                   Submit
//                 </Button>
//               </div>
//             </Form>
//           </div>
//         </Container>
//       </div>
//     </>
//   );
// };

// export default CreateStockTransferForm;

import { Autocomplete } from "@mui/material";
import MultiFileUploadInput from "Common/Components/FileUploadInput/MultipleFilterUploadinput";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import { WarehouseAxios } from "api/WarehouseAxios";
import { Axios } from "api/axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import * as Yup from "yup";

interface FieldStockItem {
  material_name: string;
  item_name: string;
  itemSKU: string;
  unit: string;
  category: string;
  subCategory: string;
  quantity: number;
  remarks: string;
  make: string;
  model: string;
}

interface FieldStockFormValues {
  stock_transfer_id: string;
  transfer_date: string;
  transfer_from: any;
  warehouse_type: string;
  transfer_to: any;
  initiatedBy: string;
  document?: File[] | null;
  remarks: string;
  transferitems: FieldStockItem[];
}
interface Dropdown {
  warehouse_id: string;
  warehouse_name: string;
}

const CreateStockTransferForm: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const [isStockCreating, setIsStockCreating] = useState<boolean>(false);
  const [isTransferToLoading, setIsTransferToLoading] =
    useState<boolean>(false);

  const [itemOptions, setItemOptions] = useState<any[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
  const [subCategoryOptions, setSubCategoryOptions] = useState<any[]>([]);
  const [unitOptions, setUnitOptions] = useState<any[]>([]);
  const [makeOptions, setMakeOptions] = useState<any[]>([]);
  const [modelOptions, setModelOptions] = useState<any[]>([]);
  // const [unitOptions, setUnitOptions] = useState<[]>([]);
  const [transferFromOptions, setTransferFromOptions] = useState<[]>([]);
  const [warehouseTypeOptions, setWarehouseTypeOptions] = useState<any[]>([
    "Project Warehouse",
    "O&M Warehouse",
  ]);
  // const [transferToOptions, setTransferToOptions] = useState<Dropdown[]>([
  //   {
  //     id: "a8227d10-21fa-4990-a6e4-96815ad14d3d",
  //     warehouse_name: "New Hoto Warehouse",
  //   },
  //   {
  //     id: "06fa3eed-d4ad-40ea-ae68-f573fc622807",
  //     warehouse_name: "Warehosue 1",
  //   },
  // ]);
  const [item, setItem] = useState<any>(null);
  // const [category, setCategory] = useState<any>(null);
  // const [subCategory, setSubCategory] = useState<any>(null);
  // const [unit, setUnit] = useState<any>(null);
  // const [make, setMake] = useState<any>(null);
  // const [model, setModel] = useState<any>(null);

  const [transferToOptions, setTransferToOptions] = useState<Dropdown[]>([]);
  // const [makeOptions, setMakeOptions] = useState<[]>([]);
  // const [modelOptions, setModelOptions] = useState<[]>([]);
  const [item_name, setItemName] = useState<{
    item_id: string;
    item_name: string;
  } | null>(null);
  const [category, setCategory] = useState<any>("");
  const [subCategory, setSubCategory] = useState<any>("");
  const [inStock, setInStock] = useState<string>("-");
  const [transfer_quantity, setQuantity] = useState<string>("");
  const [unit, setUnit] = useState<any>(null);
  const [make, setMake] = useState<any>(null);
  const [model, setModel] = useState<any>(null);
  const [remarks, setRemarks] = useState<string>("");
  const [barcode_type, set_barcode_type] = useState<string>("");

  const [itemDetails, setItemDetails] = useState<any[]>([]);
  const [tab, setTab] = useState<number>(1);
  const [showModal, setShowModal] = useState(false);
  const [items, setItems] = useState<any>([]);
  const [editIndex, setEditIndex] = useState<any>(null);
  const [errors, setErrors] = useState<{
    item?: string;
    item_name?: string;
    unit?: string;
    transfer_quantity?: string;
    category?: string;
    subCategory?: string;
    make?: string;
    model?: string;
  }>({});

  const validateFields = () => {
    const newErrors: any = {};

    if (!item_name) newErrors.item_name = "Item Name is required";
    if (!item) newErrors.item = "Item Name is required";
    if (!category) newErrors.category = "Category is required";
    if (!subCategory) newErrors.subCategory = "Sub Category is required";
    if (!unit) newErrors.unit = "Unit is required";
    if (!make) newErrors.make = "Make is required";
    if (!model) newErrors.model = "Model is required";
    if (!transfer_quantity || Number(transfer_quantity) <= 0)
      newErrors.transfer_quantity = "Quantity is required and must be > 0";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // useEffect(() => {
  //   console.log("itemDetails:", itemDetails);
  // }, [itemDetails]);

  const fetchCategories = async (item_name: string) => {
    const res = await WarehouseAxios(
      `/stock/items/?warehouse_id=${formik.values.transfer_from.warehouse_id}&item_name=${item_name}`
    );
    const data = res.data.category_name;
    setCategoryOptions(data);
  };

  const fetchSubCategories = async (category_name: string) => {
    // const res = await fetch(`/stock/items/?warehouse_id=${formik.values.transfer_from.warehouse_id}&item_name=${item_name?.item_name}&category_name=${subCategory}`);
    // const data = await res.json();
    const res = await WarehouseAxios(
      `/stock/items/?warehouse_id=${formik.values.transfer_from.warehouse_id}&item_name=${item?.item_name}&category_name=${category_name}`
    );
    const data = res.data.subcategory_name;
    setSubCategoryOptions(data);
  };

  const fetchUnits = async (subcategory_name: string) => {
    const res = await WarehouseAxios(
      `/stock/items/?warehouse_id=${formik.values.transfer_from.warehouse_id}&item_name=${item?.item_name}&category_name=${category}&subcategory_name=${subcategory_name}`
    );
    const data = res.data.unit;
    setUnitOptions(data);
  };

  const fetchMakes = async (unit: string) => {
    const res = await WarehouseAxios(
      `/stock/items/?warehouse_id=${formik.values.transfer_from.warehouse_id}&item_name=${item?.item_name}&category_name=${category}&subcategory_name=${subCategory}&unit=${unit}`
    );
    const data = res.data.make;
    setMakeOptions(data);
  };

  const fetchModels = async (make: string) => {
    const res = await WarehouseAxios(
      `/stock/items/?warehouse_id=${formik.values.transfer_from.warehouse_id}&item_name=${item?.item_name}&category_name=${category}&subcategory_name=${subCategory}&unit=${unit}&make=${make}`
    );
    const data = res.data.model;
    setModelOptions(data);
  };
  const fetchInStock = async (model: string) => {
    const res = await WarehouseAxios(
      `/stock/items/?warehouse_id=${formik.values.transfer_from.warehouse_id}&item_name=${item?.item_name}&category_name=${category}&subcategory_name=${subCategory}&unit=${unit}&make=${make}&model=${model}`
    );
    const data = res.data.total_quantity;
    const barcode_type = res.data.barcode_type;
    setInStock(data);
    set_barcode_type(barcode_type);
  };

  useEffect(() => {
    Axios?.get("/warehouse/warehouse-dropdown-by-user/")
      .then((success) => {
        setTransferFromOptions(success?.data.data || []);
      })
      .catch((err) => {
        toast.error("Failed to fetch Transfer From dropdown");
      });
  }, []);

  const autoFillDataBasedOnSelectedItem = async (val: {
    item_name: string;
    item_id: string;
  }) => {
    try {
      setItemName(val);
      const response = await WarehouseAxios.get(
        `stock/item/dropdown/?item_name=${val.item_name}`
      );
      const responseOfDropDowns = await WarehouseAxios.get(
        `stock/item-make-model/dropdown/?item_name=${val.item_name}`
      );
      const makeAndModel = responseOfDropDowns.data.data;
      const responseBasedOnSelectedItem = response.data.data[0];

      setCategory(responseBasedOnSelectedItem?.category_name || "-");
      setSubCategory(responseBasedOnSelectedItem?.subcategory_name || "-");
      setInStock(responseBasedOnSelectedItem?.in_stock_quantity || "-");
      setUnit({
        // id: responseBasedOnSelectedItem?.unit,
        uom_name: responseBasedOnSelectedItem?.unit,
      });
      setMakeOptions(makeAndModel?.makes || []);
      setModelOptions(makeAndModel?.models || []);
      // setModel(responseBasedOnSelectedItem?.model)
      // setMake(responseBasedOnSelectedItem?.make);
      // setModel(responseBasedOnSelectedItem?.model);
      // setInStock(responseBasedOnSelectedItem?.total_stock);
    } catch (err: any) {
      toast.error("Failed to fetch data based on selected Item");
    }
  };

  const fetchDataForModel = async (make: string) => {
    try {
      const resp = await WarehouseAxios.get(
        `stock/item-make-model/dropdown/?item_name=${encodeURIComponent(
          item_name?.item_name || ""
        )}&make=${encodeURIComponent(make)}`
      );
      setModelOptions(resp.data.data.models);
      // setModelOptions([])
    } catch (err: any) {
      toast.error("Failed to fetch Models based on Selected Make");
    } finally {
    }
  };
  const setInStockQantityBasedOnSelectedModal = async (val: string) => {
    if (val) {
      try {
        const resp = await WarehouseAxios.get(
          `stock/item-make-model/dropdown/?item_name=${item_name?.item_name}&make=${make}&model=${val}`
        );
        setInStock(resp?.data?.data?.total_stock);
      } catch (err: any) {
      } finally {
      }
    }
  };
  const checkIfItemDetailsAlreadyPresent = (
    newItem: any,
    itemDetails: any[]
  ): boolean => {
    const exists = itemDetails.some(
      (item) =>
        item.item_name == newItem.item_name &&
        item.modal == newItem.modal &&
        item.make == newItem.make
    );
    if (exists) {
      toast.error("Item already exists !");
      return true;
    } else {
      return false;
    }
  };
  const handleQuantityChange = (value: number) => {
    if (value > Number(inStock)) {
      toast.error(
        `Entered quantity cannot exceed available stock (${inStock})`
      );
      setQuantity(inStock);
    } else {
      setQuantity(String(value));
    }
  };

  const formik = useFormik<FieldStockFormValues>({
    initialValues: {
      stock_transfer_id: "",
      transfer_date: "",
      transfer_from: null,
      warehouse_type: "",
      transfer_to: null,
      initiatedBy: "",
      remarks: "",
      document: null,
      transferitems: [],
    },
    validationSchema: Yup.object({
      // stock_transfer_id: Yup.string().required(
      //   "Please enter Stock Trasnfer Id"
      // ),
      transfer_date: Yup.string().required("Please select a Transfer Date"),
      transfer_from: Yup.object()
        .nullable()
        .required("Please select a Transfer From"),
      warehouse_type: Yup.string().required("Please select a Warehouse Type"),
      transfer_to: Yup.object()
        .required("Please select a Transfer To")
        .typeError("Please select a valid Transfer To"),
      initiatedBy: Yup.string().required("Please select a Initiated By"),
      remarks: Yup.string(),
      // required("Please enter Remarks"),
      // transferitems: Yup.array()
      //   .of(
      //     Yup.object().shape({
      //       item_name: Yup.string().required("Required"),
      //       remarks: Yup.string(),
      //       transfer_quantity: Yup.number().required("Required").positive("Must be > 0"),
      //       unit: Yup.string().required("Required"),
      //     })
      //   )
      //   .min(1, "At least one item is required"),
    }),
    onSubmit: async (values) => {
      if (itemDetails.length === 0) {
        Swal.fire({
          icon: "warning",
          // title: "No Items Added",
          text: "Please add at least one item to the transfer list.",
          confirmButtonColor: "#3F7DDA",
        });
        return; // Stop further execution
      }

      // const payload = {
      //   stock_transfer_id: "22",
      //   transfer_date: values.transfer_date,
      //   transferred_from: values.transfer_from?.warehouse_id || "",
      //   transferred_from_name: values.transfer_from?.warehouse_name || "",
      //   transferred_from_code: values.transfer_from?.warehouse_code || "",
      //   transferred_from_type: values.transfer_from?.warehouse_type || "",
      //   warehouse_type: values.warehouse_type,
      //   transferred_to: values.transfer_to,
      //   transferred_to_name:
      //     transferToOptions.find((d) => d.id === values.transfer_to)
      //       ?.warehouse_name || "",
      //   transferred_to_code:
      //     transferToOptions.find((d) => d.id === values.transfer_to)?.id || "",
      //   transferred_to_type:
      //     transferToOptions.find((d) => d.id === values.transfer_to)?.id || "",
      //   initiated_by: values.initiatedBy,
      //   remarks: values.remarks,
      //   transferitems: itemDetails.map((item) => ({
      //     item: item.id,
      //     category: item.category,
      //     subcategory: item.sub_category,
      //     unit: item.unit,
      //     make: item.make,
      //     model: item.modal,
      //     transfer_quantity: Number(item.transfer_quantity),
      //     remarks: item.remarks,
      //   })),
      //   documents: values.document || null,
      // };

      const formData = new FormData();

      // formData.append("stock_transfer_id", "22");
      formData.append("issue_for_packing", "False");
      formData.append("transfer_date", values.transfer_date);
      formData.append(
        "transferred_from",
        values.transfer_from?.warehouse_id || ""
      );
      formData.append(
        "transferred_from_name",
        values.transfer_from?.warehouse_name || ""
      );
      formData.append(
        "transferred_from_code",
        values.transfer_from?.warehouse_code || ""
      );
      formData.append(
        "transferred_from_type",
        values.transfer_from?.warehouse_type || ""
      );
      formData.append("warehouse_type", values.warehouse_type);
      formData.append("transferred_to", values.transfer_to?.warehouse_id);

      // formData.append(
      //   "transferred_to_name",
      //   transferToOptions.find((d) => d.warehouse_id === values.transfer_to)
      //     ?.warehouse_name || ""
      // );
      // formData.append(
      //   "transferred_to_code",
      //   transferToOptions.find((d) => d.warehouse_id === values.transfer_to)
      //     ?.warehouse_id || ""
      // );
      // formData.append(
      //   "transferred_to_type",
      //   transferToOptions.find((d) => d.warehouse_id === values.transfer_to)
      //     ?.warehouse_id || ""
      // );
      formData.append(
        "transferred_to_name",
        values.transfer_to?.warehouse_name || ""
      );
      formData.append(
        "transferred_to_code",
        values.transfer_to?.warehouse_code || ""
      );
      formData.append(
        "transferred_to_type",
        values.transfer_to?.warehouse_type || ""
      );

      formData.append("initiated_by", values.initiatedBy);
      formData.append("remarks", values.remarks || "");
      if (values.document?.length) {
        values.document.forEach((file) => {
          formData.append("documents", file);
        });
      }

      // formData.append("issue_for_packing", values.issue_for_packing ? "true" : "false");

      formData.append(
        "transferitems",
        JSON.stringify(
          itemDetails.map((item) => ({
            item: item.id,
            category: item.category,
            subcategory: item.sub_category,
            barcode_type: item?.barcode_type,
            unit: item.unit,
            make: item.make,
            model: item.modal,
            transfer_quantity: Number(item.transfer_quantity),
            in_stock_quantity: Number(item.in_stock),
            remarks: item.remarks,
          }))
        )
      );
      // formData.forEach((value, key) => {
      //   console.log(`${key}: ${value}`);
      // });

      try {
        //I want to see formData's Values here at once

        // formData.forEach((value, key) => {
        //   console.log(`${key}: ${value}`);
        // });
        setIsStockCreating(true);
        const response: any = await WarehouseAxios.post(
          `/stock/create/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        toast.success("Stock Transfer Created Sucessfully ");
        navigate("/warehouse-transfer-request");
        // navigate("/warehouse-in-stock");
      } catch (err: any) {
        toast.error(err.message || "Something went wrong");
      } finally {
        setIsStockCreating(false);
      }
    },
  });

  return (
    <>
      <div
        className="page-content px-4"
        // style={{ backgroundColor: "#e9ecef", minHeight: "100vh" }}
      >
        <Container
          fluid
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "30px",
            boxShadow: "0 0 15px rgba(0,0,0,0.05)",
          }}
        >
          <div>
            <Form autoComplete="off" onSubmit={formik.handleSubmit}>
              <Row className="align-items-center mb-4">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
                  {/* Left: Back icon and heading */}
                  <div className="d-flex align-items-center gap-2">
                    <span
                      style={{ fontSize: "24px", cursor: "pointer" }}
                      onClick={() => navigate(-1)}
                    >
                      ←
                    </span>
                    <h5 className="mb-0 fw-bold">
                      {/* {isEdit ? "Edit Package" : "Create Package"} */}
                      Create Stock Transfer
                    </h5>
                  </div>

                  {/* Right: Breadcrumb */}
                  <div className="text-muted">
                    <Link
                      to="/warehouse-in-stock"
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      Warehouse
                    </Link>{" "}
                    &gt;{" "}
                    <Link
                      // to={`/${
                      //   isEdit ? `edit-package/${id}` : "add-package"
                      // }`}
                      to="#"
                      onClick={(e) => e.preventDefault()}
                      style={{ color: "inherit", textDecoration: "none" }}
                    >
                      {/* {isEdit ? "Edit Package" : "Create Package"} */}
                      Create Stock Transfer
                    </Link>
                  </div>
                </div>
              </Row>
              <Row>
                <Col lg={3} className="mb-3">
                  <Form.Label>
                    Transfer Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    name="transfer_date"
                    value={formik.values.transfer_date}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      !!formik.errors.transfer_date &&
                      formik.touched.transfer_date
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.transfer_date}
                  </Form.Control.Feedback>
                </Col>

                {/* Transfer From */}
                <Col lg={3}>
                  <div className="mb-4">
                    <Form.Label>
                      Transfer From <span className="text-danger">*</span>
                    </Form.Label>

                    <Autocomplete
                      options={transferFromOptions}
                      getOptionLabel={(option: any) =>
                        typeof option === "string"
                          ? option
                          : option.warehouse_name
                      }
                      value={formik.values.transfer_from || null}
                      onChange={(event, selected) => {
                        formik.setFieldValue("transfer_from", selected || null);

                        if (!selected?.warehouse_id) {
                          // No warehouse selected, clear state and exit
                          setItemOptions([]);
                          setItemName(null);
                          return;
                        }

                        WarehouseAxios.get(
                          `stock/items/?warehouse_id=${selected.warehouse_id}`
                        )
                          .then((success) => {
                            setItemOptions(success?.data.item_name || []);
                            setItemName(null);
                          })
                          .catch((err) => {
                            setItemOptions([]);
                            setItemName(null);
                            toast.error("Failed to fetch Item dropdown");
                          });
                      }}
                      onBlur={() =>
                        formik.setFieldTouched("transfer_from", true)
                      }
                      renderInput={(params) => (
                        <BootstrapTextField
                          {...params}
                          name="transfer_from"
                          placeholder="Select Transfer From"
                          error={
                            formik.touched.transfer_from &&
                            Boolean(formik.errors.transfer_from)
                          }
                          fullWidth
                          size="small"
                        />
                      )}
                    />
                  </div>
                </Col>

                {/* Warehouse Type */}
                <Col lg={3}>
                  <div className="mb-4">
                    <Form.Label>
                      Warehouse Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Autocomplete
                      disabled={!formik?.values?.transfer_from}
                      options={warehouseTypeOptions}
                      getOptionLabel={(option: any) => option}
                      value={formik?.values?.warehouse_type}
                      onChange={(event, newVal) => {
                        formik.setFieldValue("warehouse_type", newVal || "");
                        formik.setFieldValue("transfer_to", null);
                        if (!formik.values.transfer_from?.warehouse_id) {
                          toast.error("Please select Transfer From !");
                          return;
                        }
                        if (newVal) {
                          setIsTransferToLoading(true);
                          formik.setFieldValue("transfer_to", null);
                          Axios.get(
                            `/warehouse/excluded-warehouse-id-dropdown/?warehouse_id=${
                              formik.values.transfer_from?.warehouse_id
                            }&warehouse_type=${encodeURIComponent(newVal)}`
                          )
                            .then((res: any) => {
                              setTransferToOptions(res.data.data);
                            })
                            .catch((err: any) => {
                              toast.error("Failed to load Transfer To options");
                              setTransferToOptions([]);
                            })
                            .finally(() => {
                              setIsTransferToLoading(false);
                            });
                        } else {
                          setTransferToOptions([]);
                          toast.error("Please select Warehouse Type !");
                        }
                      }}
                      onBlur={() =>
                        formik.setFieldTouched("warehouse_type", true)
                      }
                      renderInput={(params) => (
                        <BootstrapTextField
                          {...params}
                          name="warehouse_type"
                          placeholder="Select Warehouse Type"
                          error={
                            formik.touched.warehouse_type &&
                            Boolean(formik.errors.warehouse_type)
                          }
                          helperText={
                            formik.touched.warehouse_type &&
                            formik.errors.warehouse_type
                          }
                          fullWidth
                          size="small"
                        />
                      )}
                    />
                  </div>
                </Col>

                <Col lg={3}>
                  <div className="mb-4">
                    <Form.Label>
                      Transfer To <span className="text-danger">*</span>
                    </Form.Label>
                    <Autocomplete
                      disabled={!formik?.values?.warehouse_type}
                      loading={isTransferToLoading}
                      options={transferToOptions}
                      getOptionLabel={(option: any) =>
                        typeof option === "string"
                          ? option
                          : option.warehouse_name
                      }
                      value={formik.values.transfer_to || null}
                      onChange={(event, selected) => {
                        formik.setFieldValue("transfer_to", selected || null);
                      }}
                      onBlur={() => formik.setFieldTouched("transfer_to", true)}
                      renderInput={(params) => (
                        <BootstrapTextField
                          {...params}
                          name="transfer_to"
                          placeholder="Select Transfer To"
                          error={
                            formik.touched.transfer_to &&
                            Boolean(formik.errors.transfer_to)
                          }
                          // helperText={
                          //   formik.touched.transfer_from &&
                          //   formik.errors.transfer_from
                          // }
                          fullWidth
                          size="small"
                        />
                      )}
                    />
                  </div>
                </Col>

                <Col lg={3} className="mb-3">
                  <Form.Label>
                    Initiated By <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="initiatedBy"
                    placeholder="Enter Initiated By"
                    value={formik.values.initiatedBy}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      !!formik.errors.initiatedBy && formik.touched.initiatedBy
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.initiatedBy}
                  </Form.Control.Feedback>
                </Col>

                <Col lg={3}>
                  <MultiFileUploadInput
                    label="Document"
                    name="document"
                    formik={formik}
                  />
                </Col>

                <Col lg={3}>
                  <div className="mb-3">
                    <Form.Label>
                      Remarks
                      {/* <span className="text-danger">*</span> */}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="remarks"
                      placeholder="Enter Remarks"
                      value={formik.values.remarks}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={
                        !!formik.errors.remarks && formik.touched.remarks
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.remarks}
                    </Form.Control.Feedback>
                  </div>
                </Col>
                <div>
                  <div className="mb-4 ">
                    <div className="mb-2" style={{ overflowX: "auto" }}>
                      <Table bordered>
                        <thead className="table-light">
                          <tr>
                            {/* <th style={{ minWidth: "100px" }}>Sr No.</th> */}
                            <th style={{ minWidth: "200px" }}>Item Name</th>
                            <th style={{ minWidth: "180px" }}>Category</th>
                            <th style={{ minWidth: "180px" }}>Sub-Category</th>
                            <th style={{ minWidth: "150px" }}>Unit</th>
                            <th style={{ minWidth: "150px" }}>Make</th>
                            <th style={{ minWidth: "150px" }}>Model</th>
                            <th style={{ minWidth: "150px" }}>In Stock</th>
                            <th style={{ minWidth: "230px" }}>
                              Transfer Quantity
                            </th>
                            <th style={{ minWidth: "100px" }}>Remarks</th>
                            <th style={{ minWidth: "100px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {/* <td>-</td> */}
                            <td style={{ minWidth: 160 }}>
                              <Autocomplete
                                disabled={!formik?.values?.transfer_from}
                                options={itemOptions}
                                // getOptionLabel={(option) => option.item_name}
                                getOptionLabel={(option) => {
                                  if (
                                    option instanceof Object &&
                                    !Array.isArray(option)
                                  ) {
                                    return option?.item_name;
                                  } else {
                                    return option;
                                  }
                                }}
                                value={item}
                                onChange={(e, val) => {
                                  setItem(val);
                                  setItemName(val);
                                  setCategory(null);
                                  setSubCategory(null);
                                  setUnit(null);
                                  setMake(null);
                                  setModel(null);
                                  setQuantity("");
                                  setInStock("");
                                  setRemarks("");
                                  if (val) {
                                    // fetch categories for selected item
                                    fetchCategories(val.item_name);
                                  }
                                }}
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    size="small"
                                    placeholder="Select Item"
                                    error={!!errors.item}
                                    helperText={errors.item}
                                  />
                                )}
                              />
                            </td>
                            <td style={{ minWidth: 160 }}>
                              <Autocomplete
                                disabled={!item}
                                options={categoryOptions}
                                getOptionLabel={(option) => option}
                                // getOptionLabel={(option) => {
                                //   if (option instanceof Object && !Array.isArray(option)) {
                                //     return option?.category_name;
                                //   } else {
                                //     return option;
                                //   }
                                // }}
                                value={category}
                                onChange={(e, val) => {
                                  setCategory(val);
                                  setSubCategory(null);
                                  setUnit(null);
                                  setMake(null);
                                  setModel(null);
                                  setInStock("");
                                  setQuantity("");
                                  setRemarks("");
                                  if (val) fetchSubCategories(val);
                                }}
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    size="small"
                                    placeholder="Select Category"
                                    error={!!errors.category}
                                    helperText={errors.category}
                                  />
                                )}
                              />
                            </td>
                            <td style={{ minWidth: 160 }}>
                              <Autocomplete
                                disabled={!category}
                                options={subCategoryOptions}
                                getOptionLabel={(option) => option}
                                // getOptionLabel={(option) => {
                                //   if (option instanceof Object && !Array.isArray(option)) {
                                //     return option?.sub_category_name;
                                //   } else {
                                //     return option;
                                //   }
                                // }}
                                value={subCategory}
                                onChange={(e, val) => {
                                  setSubCategory(val);
                                  setUnit(null);
                                  setMake(null);
                                  setModel(null);
                                  setInStock("");
                                  setQuantity("");
                                  setRemarks("");
                                  if (val) fetchUnits(val);
                                }}
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    size="small"
                                    placeholder="Select Subcategory"
                                    error={!!errors.subCategory}
                                    helperText={errors.subCategory}
                                  />
                                )}
                              />
                            </td>
                            {/* <td>
                              <div
                                className="form-control"
                                style={{ backgroundColor: "#fff" }}
                              >
                                {unit?.uom_name || "-"}
                              </div>
                            </td> */}

                            <td style={{ minWidth: 180 }}>
                              <Autocomplete
                                disabled={!subCategory}
                                options={unitOptions}
                                // getOptionLabel={(option) => option.unit_name}
                                getOptionLabel={(option) => {
                                  if (
                                    option instanceof Object &&
                                    !Array.isArray(option)
                                  ) {
                                    return option?.unit_name;
                                  } else {
                                    return option;
                                  }
                                }}
                                value={unit}
                                onChange={(e, val) => {
                                  setUnit(val);
                                  setMake(null);
                                  setModel(null);
                                  setInStock("");
                                  setQuantity("");
                                  setRemarks("");
                                  if (val) fetchMakes(val);
                                }}
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    size="small"
                                    placeholder="Select Unit"
                                    error={!!errors.unit}
                                    helperText={errors.unit}
                                  />
                                )}
                              />
                            </td>
                            <td style={{ minWidth: 180 }}>
                              <Autocomplete
                                options={makeOptions}
                                disabled={!unit}
                                getOptionLabel={(option) => option}
                                value={make}
                                onChange={(e, val) => {
                                  if (val) {
                                    setMake(val);
                                    setModel(null);
                                    setModelOptions([]);
                                    fetchModels(val);
                                    setInStock("");
                                    setQuantity("");
                                    setRemarks("");
                                  } else {
                                    setMake("");
                                    setModel(null);
                                    setModelOptions([]);
                                    setInStock("");
                                    setQuantity("");
                                    setRemarks("");
                                  }
                                }}
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    size="small"
                                    placeholder="Select Make"
                                    error={!!errors.make}
                                    helperText={errors.make}
                                  />
                                )}
                              />
                            </td>
                            <td style={{ minWidth: 180 }}>
                              <Autocomplete
                                disabled={!make}
                                options={modelOptions}
                                getOptionLabel={(option) => option}
                                value={model}
                                onChange={(e, val) => {
                                  setModel(val);
                                  setInStock("");
                                  fetchInStock(val);
                                  setQuantity("");
                                  setRemarks("");
                                  // setInStockQantityBasedOnSelectedModal(val);
                                }}
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    size="small"
                                    placeholder="Select Model"
                                    error={!!errors?.model}
                                    helperText={errors?.model}
                                  />
                                )}
                              />
                            </td>
                            <td>
                              <div
                                className="form-control"
                                style={{
                                  backgroundColor: "#fff",
                                  minHeight: 39,
                                }}
                              >
                                {inStock}
                              </div>
                            </td>
                            <td style={{ minWidth: 100 }}>
                              <Form.Control
                                style={{ minHeight: 40, fontSize: 14 }}
                                placeholder="Enter Transfer Quantity"
                                type="number"
                                size="sm"
                                value={transfer_quantity}
                                onChange={(e) =>
                                  handleQuantityChange(Number(e.target.value))
                                }
                                isInvalid={!!errors.transfer_quantity}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.transfer_quantity}
                              </Form.Control.Feedback>
                            </td>
                            <td style={{ minWidth: 160 }}>
                              <Form.Control
                                style={{ minHeight: 40, fontSize: 14 }}
                                placeholder="Enter Remarks"
                                type="text"
                                size="sm"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                              />
                            </td>
                            <td>
                              <Button
                                style={{
                                  backgroundColor: "#3F7DDA",
                                  color: "#FFF",
                                }}
                                onClick={() => {
                                  if (validateFields()) {
                                    const newItem = {
                                      id: item_name?.item_id,
                                      item: item_name?.item_id,
                                      item_name:
                                        item_name?.item_name ?? item_name,
                                      category,
                                      barcode_type: barcode_type,
                                      sub_category: subCategory,
                                      in_stock: inStock,
                                      transfer_quantity,
                                      make: make || "",
                                      modal: model || "",
                                      unit: unit?.uom_name || unit || "",
                                      remarks,
                                    };

                                    if (editIndex !== null) {
                                      // Update mode
                                      const updatedItems = [...itemDetails];
                                      updatedItems[editIndex] = newItem;
                                      setItemDetails(updatedItems);
                                      setEditIndex(null); // Exit edit mode
                                    } else {
                                      // Add mode
                                      if (
                                        !checkIfItemDetailsAlreadyPresent(
                                          newItem,
                                          itemDetails
                                        )
                                      )
                                        setItemDetails([
                                          ...itemDetails,
                                          newItem,
                                        ]);
                                    }

                                    // Reset form
                                    setItemName(null);
                                    setItem("");
                                    setCategory("");
                                    setSubCategory("");
                                    setInStock("");
                                    set_barcode_type("");
                                    setQuantity("");
                                    setUnit(null);
                                    setMake(null);
                                    setModel(null);
                                    setRemarks("");
                                    setErrors({});
                                  }
                                }}
                              >
                                {editIndex !== null ? "UPDATE" : "ADD"}
                              </Button>
                            </td>
                          </tr>

                          {itemDetails.map((item, index: number) => (
                            <tr key={index}>
                              {/* <td>{index + 1}</td> */}
                              <td>{item.item_name}</td>
                              <td>{item.category}</td>
                              <td>{item.sub_category}</td>
                              <td>{item.unit}</td>
                              <td>{item.make}</td>
                              <td>{item.modal}</td>
                              <td>{item.in_stock}</td>
                              <td>{item.transfer_quantity}</td>

                              <td>{item.remarks || "-"}</td>
                              <td>
                                <div className="d-flex justify-content-center gap-3">
                                  <Button
                                    size="sm"
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                      padding: 0,
                                    }}
                                    onClick={() => {
                                      const selected = itemDetails[index];
                                      setItemName({
                                        item_name: selected.item_name,
                                        item_id: selected.item,
                                      });
                                      setItem({
                                        item_name: selected.item_name,
                                        item_id: selected.item,
                                      });

                                      setCategory(selected.category);
                                      setSubCategory(selected.sub_category);
                                      setUnit(selected.unit);
                                      setMake(selected.make);
                                      setModel(selected.modal);
                                      setQuantity(selected.transfer_quantity);
                                      setRemarks(selected.remarks);
                                      setEditIndex(index);
                                      setInStock(selected.in_stock);
                                    }}
                                  >
                                    <i
                                      className="bi bi-pencil-fill"
                                      style={{ color: "#3F7DDA", fontSize: 17 }}
                                    ></i>
                                  </Button>

                                  <Button
                                    size="sm"
                                    style={{
                                      backgroundColor: "transparent",
                                      border: "none",
                                      padding: 0,
                                    }}
                                    onClick={() => {
                                      const updated = [...itemDetails];
                                      updated.splice(index, 1);
                                      setItemDetails(updated);
                                    }}
                                  >
                                    <i
                                      className="bi bi-trash-fill"
                                      style={{ color: "red", fontSize: 17 }}
                                    ></i>
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </Row>

              <div className="d-flex justify-content-center gap-3 py-3">
                <Button
                  variant="light"
                  onClick={() => navigate("/warehouse-in-stock")}
                  style={{ border: "1px solid #ced4da" }}
                >
                  <span
                    className="text-decoration-none"
                    style={{ color: "#495057" }}
                  >
                    Cancel
                  </span>
                </Button>

                <Button
                  type="submit"
                  style={{
                    background: "#3F7DDA",
                    color: "#FFF",
                    minWidth: "70px",
                  }}
                >
                  {!isStockCreating ? (
                    "Submit"
                  ) : (
                    <Spinner animation="border" size="sm" />
                  )}
                  {/* Submit */}
                </Button>
              </div>
            </Form>
          </div>
        </Container>
      </div>
    </>
  );
};

export default CreateStockTransferForm;
